<script>
import SummaryTable from './budget-proposal-summary-table.vue';
export default {
    name: "BudgetProposalBackPage",
    components: {
        SummaryTable
    },
    props: {
        selectedTemplate: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tabModel: null,
            overAll: {
                campuses: [],
                classifications: []
            },
            byCampus: [],
            loading: false,
            overallStatus: 'DRAFT',
            byCampusStatus: 'DRAFT',
            overallSearch: '',
            byCampusSearch: '',
            isGroupedCampusOpened: true,
            isGroupedStructureOpened: false,
            selectedCampus: this.$store.state.data.selectedCampus?.id || 0,
            campuses: []
        }
    },
    watch: {
        tabModel: {
            immediate: true,
            async handler(newVal) {
                this.loading = true;
                if (newVal === 0) {
                    await this.getOverallSummary(this.selectedTemplate.id, this.overallStatus);
                } else if (newVal === 1) {
                    await this.getByCampusSummary(this.selectedTemplate.id, this.byCampusStatus, this.selectedCampus);
                }
                this.loading = false;
            },
        },
        overallStatus: {
            async handler(newVal) {
                this.loading = true;
                await this.getOverallSummary(this.selectedTemplate.id, newVal);
                this.loading = false;
            }
        },
        byCampusStatus: {
            async handler(newVal) {
                if (this.tabModel !== 1) return;
                this.loading = true;
                await this.getByCampusSummary(this.selectedTemplate.id, newVal, this.selectedCampus);
                this.loading = false;
            }
        },
        selectedCampus: {
            async handler(newVal) {
                if (this.tabModel !== 1) return;
                this.loading = true;
                await this.getByCampusSummary(this.selectedTemplate.id, this.byCampusStatus, newVal);
                this.loading = false;
            }
        }
    },
    mounted() {
        this.tabModel = 0;
        var campuses = [];
        this.realCampus = [];
        this.$store.state.decrypt.campusAccessList().forEach((item) => {
            campuses.push({ value: item.Id, text: item.CampusName });
        });
        this.campuses = campuses;
    },
    methods: {
        async getOverallSummary(id, status) {
            try {
                const { data: response } = await this.$store.dispatch("budgetproposaltemplate/GetSummaryOverAll", { id, status });
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                console.log(response)
                this.overAll = response;
            } catch (error) {
                this.showToast("Failed to fetch active proposals.", "error");
            }
        },
        async getByCampusSummary(id, status, campusId) {
            try {
                const { data: response } = await this.$store.dispatch("budgetproposaltemplate/GetSummaryByCampus", { id, status, campusId });
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                this.byCampus = response;
            } catch (error) {
                this.showToast("Failed to fetch shortlisted proposals.", "error");
            }
        },
    }
}
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-3 mb-4">
                <a href="javascript:void(0);" @click="$emit('back')" class="d-flex align-items-center gap-1"><i
                        class="bx bx-chevron-left"></i> Back</a>
                <h4 class="mb-0">{{ selectedTemplate.description }} - Budget Summary</h4>
            </div>
        </div>
        <template v-if="loading">
            <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
                <b-spinner label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-tabs v-model="tabModel" color="primary">
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-check me-1"></i>Overall Summary</span>
                    </template>
                    <div class="my-3 d-flex gap-2 justify-content-end">

                        <div class="d-flex gap-1 align-items-center">
                            <label for="byCampusStatus" class="mb-0">Filter Status:</label>
                            <select v-model="overallStatus" class="form-select w-200px">
                                <option value="DRAFT">DRAFT</option>
                                <option value="SHORTLISTED">SHORTLISTED</option>
                                <option value="PARKED">PARKED</option>
                                <option value="APPROVED">APPROVED</option>
                                <option value="RETURNED">RETURNED</option>
                            </select>
                        </div>
                    </div>
                    <div role="tablist" key="overall-summary-by-campus" class="w-100">
                        <b-card no-body class="mb-2 shadow-none border">
                            <b-card-header header-tag="header" role="tab" header-class="cursor-pointer hover-header"
                                @click="isGroupedCampusOpened = !isGroupedCampusOpened">
                                <div class="d-flex align-items-center justify-content-between w-100">
                                    <h5 class="mb-0 text-warning">Overall Summary Grouped By Campus</h5>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <span class="d-flex align-items-center">
                                                <small v-if="!isGroupedCampusOpened">Click here to show more
                                                    details</small><i
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{ 'rotate-90': isGroupedCampusOpened }"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse :visible="isGroupedCampusOpened" :accordion="`overall-summary-by-campus`"
                                role="tabpanel">
                                <div class="card-body pt-0 px-0">
                                    <SummaryTable :proposals="overAll.campuses" :loading="loading"
                                        reportAs="groupedByCampus" />
                                </div>
                            </b-collapse>
                        </b-card>
                    </div>
                    <div role="tablist" key="overall-summary-by-classification" class="w-100">
                        <b-card no-body class="mb-2 shadow-none border">
                            <b-card-header header-tag="header" role="tab" header-class="cursor-pointer hover-header"
                                @click="isGroupedStructureOpened = !isGroupedStructureOpened">
                                <div class="d-flex align-items-center justify-content-between w-100">
                                    <h5 class="mb-0 text-warning">Overall Summary Grouped By Cost Structure and Campus
                                    </h5>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <span class="d-flex align-items-center">
                                                <small v-if="!isGroupedStructureOpened">Click here to show more
                                                    details</small><i
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{ 'rotate-90': isGroupedStructureOpened }"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse :visible="isGroupedStructureOpened"
                                :accordion="`overall-summary-by-classification`" role="tabpanel">
                                <div class="card-body pt-0 px-0">
                                    <SummaryTable :proposals="overAll.classifications" :loading="loading"
                                        reportAs="groupedByStructure" />
                                </div>
                            </b-collapse>
                        </b-card>
                    </div>
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-check me-1"></i>By Campus Summary</span>
                    </template>
                    <div class="my-3 d-flex gap-2 justify-content-end">
                        <div class="d-flex gap-1 align-items-center">
                            <label for="byCampusStatus" class="mb-0">Filter Campus:</label>
                            <select v-model="selectedCampus" class="form-select w-300px">
                                <option v-for="x in campuses" :key="x.value" :value="x.value">{{ x.text }}</option>
                            </select>
                        </div>
                        <div class="d-flex gap-1 align-items-center">
                            <label for="byCampusStatus" class="mb-0">Filter Status:</label>
                            <select v-model="byCampusStatus" class="form-select w-200px">
                                <option value="DRAFT">DRAFT</option>
                                <option value="SHORTLISTED">SHORTLISTED</option>
                                <option value="PARKED">PARKED</option>
                                <option value="APPROVED">APPROVED</option>
                                <option value="RETURNED">RETURNED</option>
                            </select>
                        </div>
                    </div>
                    <div role="tablist" key="overall-summary-by-campus" class="w-100">
                        <b-card no-body class="mb-2 shadow-none border">
                            <SummaryTable :proposals="byCampus" :loading="loading" reportAs="groupedByDU" />
                        </b-card>
                    </div>
                </b-tab>
            </b-tabs>
        </template>
    </div>
</template>